// Rei do Pote: o saldo de mesa nas salas valendo Tentos (o que ganhou menos o que perdeu) e a linha do fim da partida.
import type { PoteDaPartida } from '@truco6/gamificacao';

// "+38", "−12" (com o sinal de menos) ou "0".
export const saldoDeMesa = (n: number) => (n > 0 ? '+' : n < 0 ? '−' : '') + Math.abs(n).toLocaleString('pt-BR');

// A linha do fim da partida valendo Tentos (canvas 8.5): "Rei do Pote: +4 · subiu para 13º", "Rei do Pote: +4 · 13º"
// ou, na derrota, "Rei do Pote: −6". Sem a posição (não chegou em 3 s ou fora da lista), só o saldo da partida.
export function linhaDoPote(saldo: number, pote: Pick<PoteDaPartida, 'posicao' | 'antes'> | null): string {
  const base = `Rei do Pote: ${saldoDeMesa(saldo)}`;
  if (saldo < 0 || !pote?.posicao) return base;
  return pote.antes === null || pote.antes > pote.posicao ? `${base} · subiu para ${pote.posicao}º` : `${base} · ${pote.posicao}º`;
}

// A posição chega da API depois da liquidação; se não chegar em 3 s, a linha fica só com o saldo da partida.
export const ESPERA_DO_POTE_MS = 3000;
export function comPrazo<T>(p: Promise<T>, ms = ESPERA_DO_POTE_MS): Promise<T | null> {
  return Promise.race([p.catch(() => null), new Promise<null>((ok) => setTimeout(() => ok(null), ms))]);
}
